// Maps backend status strings to Polaris Badge tones. Unknown statuses render
// neutral so new backend states never break the UI.

import { Badge } from "@shopify/polaris";
import type { BadgeProps } from "@shopify/polaris";

type BadgeConfig = { tone?: BadgeProps["tone"]; progress?: BadgeProps["progress"] };

// Covers content-asset, publish-target and task statuses seen in the backend.
const STATUS_TONES: Record<string, BadgeConfig> = {
  // healthy / done
  published: { tone: "success", progress: "complete" },
  verified: { tone: "success", progress: "complete" },
  monitored: { tone: "success", progress: "complete" },
  succeeded: { tone: "success", progress: "complete" },
  active: { tone: "success", progress: "complete" },
  connected: { tone: "success", progress: "complete" },
  // in progress
  validated: { tone: "info", progress: "partiallyComplete" },
  scheduled: { tone: "info", progress: "incomplete" },
  publishing: { tone: "attention", progress: "partiallyComplete" },
  running: { tone: "attention", progress: "partiallyComplete" },
  retrying: { tone: "warning", progress: "partiallyComplete" },
  retryable: { tone: "warning", progress: "partiallyComplete" },
  pending: { tone: "new", progress: "incomplete" },
  draft: { tone: undefined, progress: "incomplete" },
  // trouble
  blocked: { tone: "warning", progress: "incomplete" },
  failed: { tone: "critical", progress: "incomplete" },
  dead: { tone: "critical", progress: "incomplete" },
  dead_letter: { tone: "critical", progress: "incomplete" },
  rolled_back: { tone: "critical", progress: "incomplete" },
};

export function StatusBadge({ status }: { status: string }) {
  const cfg = STATUS_TONES[status] ?? {};
  const label = status.replace(/_/g, " ");
  return (
    <Badge tone={cfg.tone} progress={cfg.progress}>
      {label}
    </Badge>
  );
}
